export class CustomDateModel {
  date?: Date;
  timezone_type?: number;
  timezone?: string;
}
